import HomeSearch from "../../components/elements/HomeSearch";
import Container from "../../layout/Container";
import Navbar from "../../layout/Navbar";
import Hero from "../../assets/images/hero.png";
import Icon from "../../components/Icon";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import EPujaCard from "../../components/cards/EpujaCard";
import MobileView from '../mobile/EpujaDetails'
import useWidth from "../../hooks/useWidth";
import { getEPujaDetails, getEpujaList } from "../../apis";
import { useFetch } from "../../hooks/useFetch";
import { useParams } from "react-router-dom";
import { convertTo12HourFormat, dateFormat } from "../../utils";



import { useState } from "react";
import Loader from "../../components/elements/Loader";
import EpujaForm from "./EpujaForm";


export default () => {
    const width = useWidth()
    const params = useParams()
    const [form, setForm] = useState({ date: null })

    const [details,, loading] = useFetch(getEPujaDetails, {}, params.pujaId )
    const [epuja] = useFetch(getEpujaList, {})


  return (
    <>
    <Loader loading={loading} />

    {width < 992 && <MobileView details={details} list={epuja.data}/>}
      {width > 992 && (
        <>
          <Navbar gradient />
          <Container>
            <section>
              <div className="desktop-top-space pt-4">
                <div className="d-flex justify-content-center flex-column align-items-center ">
                  <h1 className="custom-heading xx-bold">Search Result</h1>
                  <HomeSearch placeholder={"Stay in Odisha"} />
                </div>
              </div>
            </section>
            <section className="">
              <h3 className="my-5 text-center custom-text-color">
                Find Your Remedy For Peace & Prosperety
              </h3>
              <div className="row">
                <div className="col-lg-8 col-md-12 p-0">
                  <div className="m-2" style={{ height: "500px" }}>
                    <img src={details.files?.at(0)?.Url || Hero} className="w-100 h-100 rounded-4" />
                  </div>
                </div>
                <div className="col-lg-4 col-md-12 p-0">
                  <EpujaForm details={details}/>
                </div>
              </div>
              <p className="custom-text-color my-4">
                <Icon icon={faCalendarAlt} className="me-2" />{ dateFormat(details.ePujaDate)},
                { details.day } (upto { details.end_at && convertTo12HourFormat(details.end_at)})
              </p>

              <h3 className="text-saffron mb-4">
                { details.title }
              </h3>
              <p className="mb-3">
                { details.description }
              </p>
              <h3 className="custom-text-color my-5">Similar Puja Havan</h3>

              <div className="w-100 overflow-auto scrollbar-hidden">
                <div className="row d-flex flex-nowrap">
                  {
                    epuja.data?.filter((a, i ) => i <= 2).map(( data, i )=> 
                      <div className="col-lg-6">
                        <EPujaCard data={data} />
                      </div>
                    )
                  }
                </div>
              </div>
            </section>
          </Container>
        </>
      )}
    </>
  );
};
